import { TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import FilteredTableDataCell from './FilteredTableDataCell';
import { ANALYTICS_DIVIDER, BROADSIGHT_PRIMARY_BLUE, withAlpha } from '../Analytics/analyticsColors';

export default function FilteredTableDataRow({ type, issue, dropdownTable, columns, isStripedRow }) {
  return (
    <>
      <TableRow
        sx={{
          backgroundColor: isStripedRow ? withAlpha(BROADSIGHT_PRIMARY_BLUE, 0.08) : '#FFFFFF',
          transition: 'background-color 120ms ease',
          '&:hover': {
            backgroundColor: withAlpha(BROADSIGHT_PRIMARY_BLUE, 0.12),
          },
        }}
        key={issue.id}
      >
        {columns.map((key, index) => (
          <FilteredTableDataCell
            type={type}
            key={key}
            data={issue.cells}
            index={key}
            dropdownTable={dropdownTable}
            cellSx={{
              px: '14px',
              py: '16px',
              textAlign: 'left',
              fontSize: '12.5px',
              fontFamily: 'Roboto, sans-serif',
              verticalAlign: 'top',
              lineHeight: 1.35,
              whiteSpace: 'normal',
              overflowWrap: 'anywhere',
              wordBreak: 'break-word',
              borderBottom: `1px solid ${ANALYTICS_DIVIDER}`,
              borderTop: 'none',
              borderLeft: index === 0 ? 'none' : `1px solid ${ANALYTICS_DIVIDER}`,
              borderRight: 'none',
            }}
          />
        ))}
      </TableRow>
    </>
  );
}

FilteredTableDataRow.propTypes = {
  columns: PropTypes.array,
  dropdownTable: PropTypes.object,
  isStripedRow: PropTypes.bool,
  issue: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    cells: PropTypes.object,
  }),
  type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
